import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { RepaymentsPage } from './pages/RepaymentsPage';
import { ApplicationsPage } from './pages/ApplicationsPage';
import { SchedulerLogsPage } from './pages/SchedulerLogsPage';
import { ActivityLogPage } from './pages/ActivityLogPage';
import { GLPostingsPage } from './pages/GLPostingsPage';
type Page = 'dashboard' | 'repayments' | 'applications' | 'glpostings' | 'scheduler' | 'activitylog';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentPage, setCurrentPage] = useState<Page>('dashboard');
  const handleLogin = () => {
    setIsAuthenticated(true);
    setCurrentPage('dashboard');
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setCurrentPage('dashboard');
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <DashboardPage onNavigate={setCurrentPage} data-id="element-0" />;
      case 'repayments':
        return <RepaymentsPage data-id="element-1" />;
      case 'applications':
        return <ApplicationsPage data-id="element-2" />;
      case 'glpostings':
        return <GLPostingsPage data-id="element-3" />;
      case 'scheduler':
        return <SchedulerLogsPage data-id="element-4" />;
      case 'activitylog':
        return <ActivityLogPage data-id="element-5" />;
      default:
        return <DashboardPage onNavigate={setCurrentPage} data-id="element-6" />;
    }
  };
  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} data-id="element-7" />;
  }
  return <Layout currentPage={currentPage} onNavigate={setCurrentPage} onLogout={handleLogout} data-id="element-8">
      {renderPage()}
    </Layout>;
}